import React from 'react'
import { Box, Color, Display, FlexDirection, Body1 } from '@gousto-internal/citrus-react'

import type { LoggedOutBoxSummaryActions, LoggedOutBoxSummaryPortionSizeView } from '../types'

type PortionSizePanelProps = {
  view: LoggedOutBoxSummaryPortionSizeView
  actions: Pick<LoggedOutBoxSummaryActions, 'onPortionSizeSelect' | 'onPortionSizeConfirm'>
}

// Scaffold: `actions` is a forward-declared contract the modal already wires up;
// it is intentionally not consumed yet and will be when this panel is built out.
export const PortionSizePanel = ({ view }: PortionSizePanelProps) => (
  <Box
    display={Display.Flex}
    flexDirection={FlexDirection.Column}
    paddingH={3}
    paddingBottom={6}
    data-testid="logged-out-box-summary-portion-size-panel"
  >
    <Body1 color={Color.ColdGrey_800}>{view.title}</Body1>
  </Box>
)
